// Reads a message from location state and resets it
// todo: extend to
//  - support any state prop name
//  - support any state prop type
// usage: const successMessage = useOneTimeSuccessMessage();

import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { SuccessBanner } from "./MessageBanner"

export const OneTimeSuccessMessage: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [message, setMessage] = useState<string | null>(null)

  useEffect(() => {
    const state = location.state as { successMessage?: string } | null
    if (state?.successMessage) {
      setMessage(state.successMessage)
      window.history.replaceState(null, "", location.pathname)
    }
  }, [location.pathname, location.state, navigate])

  return message ? <SuccessBanner message={message} /> : null
}
